/**
 * Frontend mirror of backend canUpdatePermissions.
 * super_admin: can update admin & support (not self)
 * admin: can update support only
 * support: never
 */
export function canUpdatePermissions(
  actor: { id?: number; role?: string },
  target: { id?: number; role?: string }
): boolean {
  if (!actor || !target) return false;
  if (!actor.role || !target.role) return false;

  const actorRole = String(actor.role).toLowerCase();
  const targetRole = String(target.role).toLowerCase();

  if (actorRole === 'support') return false;
  if (actorRole === 'admin') return targetRole === 'support';
  if (actorRole === 'super_admin') {
    if (actor.id === target.id) return false;
    return targetRole === 'admin' || targetRole === 'support';
  }
  return false;
}

/**
 * Can actor deactivate target admin? (no reverse)
 * super_admin: cannot be deactivated by admin/support
 * super_admin: can deactivate admin, support, other super_admin
 * admin: can deactivate support only
 * support: never
 */
export function canDeactivateAdmin(
  actor: { id?: number; role?: string },
  target: { id?: number; role?: string }
): boolean {
  if (!actor || !target) return false;
  if (!actor.role || !target.role) return false;

  const actorRole = String(actor.role).toLowerCase();
  const targetRole = String(target.role).toLowerCase();

  if (actorRole === 'support') return false;
  if (actorRole === 'admin') return targetRole === 'support';
  if (actorRole === 'super_admin') {
    if (actor.id === target.id) return false;
    return (
      targetRole === 'super_admin' ||
      targetRole === 'admin' ||
      targetRole === 'support'
    );
  }
  return false;
}
